module.exports = __webpack_public_path__ + "img/dsci0011.65df794f.jpg";